(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ---------- Header enhancement pack: transparent-header scroll toggle ---------- */
  (function () {
    var transparentWrapper = document.querySelector('.header-wrapper--transparent-header');
    if (transparentWrapper) {
      var toggleScrolledClass = function () {
        var scrolledPast = (window.pageYOffset || document.documentElement.scrollTop) > 10;
        transparentWrapper.classList.toggle('header-wrapper--scrolled', scrolledPast);
      };
      toggleScrolledClass();
      window.addEventListener('scroll', toggleScrolledClass, { passive: true });
    }
  })();

  /* ---------- Header enhancement pack: add-to-cart bump animation (anime.js) ---------- */
  (function () {
    var iconsContainer = document.querySelector('.header__icons');
    var cartLink = document.getElementById('cart-icon-bubble');
    if (!iconsContainer || !cartLink) return;
    if (cartLink.dataset.cartAnimation !== 'true') return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var animeLoading = false;
    var debounceTimer;
    var confettiCanvas = null;
    var confettiCtx = null;
    var confettiParticles = [];
    var confettiRafId = null;
    var CONFETTI_COLORS = ['#FFD700', '#FF6FA5', '#5AC8FA', '#B980F0', '#8BE05A', '#FFC93C'];

    /* Returns the numeric cart item count so we can tell an increase from a
       decrease. (Previously compared an opaque text "signature" that changed on
       ANY count change, so removing an item fired the exact same "success" path
       as adding one.) Falls back to a large sentinel for the 99+ case, where
       Dawn's markup omits the numeric span and only the bubble itself is present. */
    function getCartItemCount() {
      var link = document.getElementById('cart-icon-bubble');
      if (!link) return 0;
      var countEl = link.querySelector('.cart-count-bubble [aria-hidden="true"]');
      if (countEl) {
        var parsed = parseInt(countEl.textContent, 10);
        return isNaN(parsed) ? 0 : parsed;
      }
      return link.querySelector('.cart-count-bubble') ? 9999 : 0;
    }

    function isOnCartPage() {
      return /\/cart(\/|$)/i.test(window.location.pathname);
    }

    var lastItemCount = getCartItemCount();

    function loadAnimeThen(callback) {
      if (window.anime) return callback();
      if (animeLoading) return;
      animeLoading = true;
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/animejs@4/dist/bundles/anime.umd.min.js';
      script.onload = function () {
        animeLoading = false;
        callback();
      };
      document.head.appendChild(script);
    }

    function bumpCartIcon() {
      var link = document.getElementById('cart-icon-bubble');
      if (!link || !window.anime) return;
      var bubble = link.querySelector('.cart-count-bubble');
      var iconWrap = link.querySelector('.svg-wrapper, .header__icon-custom-image');
      var animate = window.anime.animate;
      var createSpring = window.anime.createSpring;

      if (iconWrap) {
        animate(iconWrap, {
          scale: [1, 1.22, 1],
          rotate: ['0deg', '-10deg', '10deg', '0deg'],
          duration: 550,
          ease: createSpring({ stiffness: 300, damping: 12 })
        });
      }
      if (bubble) {
        animate(bubble, {
          scale: [0, 1.2, 1],
          duration: 450,
          ease: createSpring({ stiffness: 260, damping: 14 })
        });
      }
    }

    /* Shared with card-product.liquid: any add-to-cart form records the button it
       submitted here. This observer is the single source of truth for "the add
       actually landed in the cart" (it only fires on a real count change), so we
       use it to trigger both the confetti burst and the button's success check,
       instead of guessing at Dawn's internal loading-state class names. */
    window.FunBooksCartFX = window.FunBooksCartFX || {};

    /* 3000 particles is too many individually-animated DOM elements to stay smooth
       (especially on phones), so the burst renders on a single shared <canvas> with
       one requestAnimationFrame physics loop instead. Cheap at any particle count
       since it's one draw pass per frame, not thousands of animation instances. */
    function ensureConfettiCanvas() {
      if (confettiCanvas) return confettiCanvas;
      confettiCanvas = document.createElement('canvas');
      confettiCanvas.style.position = 'fixed';
      confettiCanvas.style.top = '0';
      confettiCanvas.style.left = '0';
      confettiCanvas.style.width = '100vw';
      confettiCanvas.style.height = '100vh';
      confettiCanvas.style.pointerEvents = 'none';
      confettiCanvas.style.zIndex = '9999';
      confettiCanvas.width = window.innerWidth;
      confettiCanvas.height = window.innerHeight;
      document.body.appendChild(confettiCanvas);
      confettiCtx = confettiCanvas.getContext('2d');
      window.addEventListener(
        'resize',
        function () {
          confettiCanvas.width = window.innerWidth;
          confettiCanvas.height = window.innerHeight;
        },
        { passive: true }
      );
      return confettiCanvas;
    }

    function drawSparkle(ctx, size) {
      ctx.beginPath();
      ctx.moveTo(0, -size);
      ctx.lineTo(size * 0.22, -size * 0.22);
      ctx.lineTo(size, 0);
      ctx.lineTo(size * 0.22, size * 0.22);
      ctx.lineTo(0, size);
      ctx.lineTo(-size * 0.22, size * 0.22);
      ctx.lineTo(-size, 0);
      ctx.lineTo(-size * 0.22, -size * 0.22);
      ctx.closePath();
      ctx.fill();
    }

    function stepConfetti() {
      confettiCtx.clearRect(0, 0, confettiCanvas.width, confettiCanvas.height);

      var stillAlive = [];
      for (var i = 0; i < confettiParticles.length; i++) {
        var p = confettiParticles[i];
        p.life += 1;
        if (p.life > p.maxLife) continue;

        p.vx *= p.drag;
        p.vy = p.vy * p.drag + p.gravity;
        p.x += p.vx;
        p.y += p.vy;
        p.rotation += p.rotationSpeed;

        /* Widely-varied lifespans now mean some particles travel well past the
           viewport before their time is up — stop simulating/drawing them once
           they're off-screen instead of wastefully continuing until maxLife. */
        if (p.y > confettiCanvas.height + 60 || p.x < -60 || p.x > confettiCanvas.width + 60) continue;

        var progress = p.life / p.maxLife;
        var fadeIn = progress < 0.06 ? progress / 0.06 : 1;
        var fadeOut = progress > 0.72 ? 1 - (progress - 0.72) / 0.28 : 1;
        var popIn = progress < 0.12 ? progress / 0.12 : 1;
        var twinkle = p.shape === 'sparkle' ? 0.55 + Math.abs(Math.sin(p.life * p.twinkleSpeed)) * 0.45 : 1;
        var opacity = Math.max(0, fadeIn * fadeOut * twinkle);

        confettiCtx.save();
        confettiCtx.translate(p.x, p.y);
        confettiCtx.rotate(p.rotation);
        confettiCtx.scale(popIn, popIn);
        confettiCtx.globalAlpha = opacity;
        confettiCtx.fillStyle = p.color;

        if (p.shape === 'sparkle') {
          drawSparkle(confettiCtx, p.size);
        } else {
          confettiCtx.beginPath();
          confettiCtx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
          confettiCtx.fill();
        }
        confettiCtx.restore();

        stillAlive.push(p);
      }
      confettiParticles = stillAlive;

      if (confettiParticles.length > 0) {
        confettiRafId = requestAnimationFrame(stepConfetti);
      } else {
        confettiRafId = null;
        confettiCtx.clearRect(0, 0, confettiCanvas.width, confettiCanvas.height);
      }
    }

    function burstConfettiAt(anchorEl) {
      if (!anchorEl) return;
      ensureConfettiCanvas();
      var rect = anchorEl.getBoundingClientRect();
      var originX = rect.left + rect.width / 2;
      var originY = rect.top + rect.height / 2;

      var PARTICLE_COUNT = 3000;
      for (var i = 0; i < PARTICLE_COUNT; i++) {
        var angle = Math.random() * Math.PI * 2;
        var speed = 3 + Math.random() * 16;
        confettiParticles.push({
          x: originX,
          y: originY,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed - 7,
          gravity: 0.32 * (0.65 + Math.random() * 0.7),
          drag: 0.983 + Math.random() * 0.012,
          size: 3 + Math.random() * 7,
          color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
          shape: Math.random() < 0.35 ? 'sparkle' : 'circle',
          rotation: Math.random() * Math.PI * 2,
          rotationSpeed: (Math.random() - 0.5) * 0.5,
          twinkleSpeed: 0.2 + Math.random() * 0.4,
          life: 0,
          /* Skewed toward shorter lifespans (most vanish within ~1s) with a long
             tail of stragglers lingering much longer (up to ~3.3s), instead of a
             flat range — reads as dust settling unevenly rather than one
             synchronized "poof" when the batch's average lifespan runs out. */
          maxLife: 35 + Math.pow(Math.random(), 1.6) * 165
        });
      }

      if (!confettiRafId) {
        confettiRafId = requestAnimationFrame(stepConfetti);
      }
    }

    function flyToCart(sourceImg) {
      if (!sourceImg) return;
      /* Fires optimistically on click, which can be before anime.js has ever
         been loaded on this page view. loadAnimeThen guarantees it's ready
         before we touch window.anime, instead of silently no-op-ing. */
      loadAnimeThen(function () {
        var cartLink = document.getElementById('cart-icon-bubble');
        if (!cartLink) return;

        var startRect = sourceImg.getBoundingClientRect();
        var endRect = cartLink.getBoundingClientRect();
        if (!startRect.width || !startRect.height) return;

        var flyer = sourceImg.cloneNode(true);
        flyer.removeAttribute('srcset');
        flyer.removeAttribute('sizes');
        flyer.removeAttribute('loading');
        flyer.style.position = 'fixed';
        flyer.style.left = startRect.left + 'px';
        flyer.style.top = startRect.top + 'px';
        flyer.style.width = startRect.width + 'px';
        flyer.style.height = startRect.height + 'px';
        flyer.style.margin = '0';
        flyer.style.borderRadius = '8px';
        flyer.style.objectFit = 'cover';
        flyer.style.pointerEvents = 'none';
        flyer.style.zIndex = '9998';
        flyer.style.boxShadow = '0 8px 24px rgba(0, 0, 0, 0.25)';
        flyer.style.willChange = 'transform, opacity';
        document.body.appendChild(flyer);

        var startCenterX = startRect.left + startRect.width / 2;
        var startCenterY = startRect.top + startRect.height / 2;
        var endCenterX = endRect.left + endRect.width / 2;
        var endCenterY = endRect.top + endRect.height / 2;

        var deltaX = endCenterX - startCenterX;
        var deltaY = endCenterY - startCenterY;
        /* slight arc: overshoot upward partway through the flight, like it's being tossed */
        var midX = deltaX * 0.5 + (Math.random() - 0.5) * 60;
        var midY = Math.min(deltaY * 0.35, deltaY) - 80;

        window.anime.animate(flyer, {
          duration: 750,
          ease: 'linear',
          rotate: (Math.random() > 0.5 ? 1 : -1) * (15 + Math.random() * 20),
          translateX: [
            { to: midX, duration: 350, ease: 'outQuad' },
            { to: deltaX, duration: 400, ease: 'inQuad' }
          ],
          translateY: [
            { to: midY, duration: 350, ease: 'outQuad' },
            { to: deltaY, duration: 400, ease: 'inQuad' }
          ],
          scale: [
            { to: 1, duration: 350, ease: 'outQuad' },
            { to: 0.15, duration: 400, ease: 'inQuad' }
          ],
          opacity: [
            { to: 1, duration: 550 },
            { to: 0, duration: 200 }
          ],
          onComplete: function () {
            flyer.remove();
          }
        });
      });
    }

    window.FunBooksCartFX.flyToCart = flyToCart;

    function showAddSuccessCheck(button) {
      if (!button || !window.anime) return;
      var check = button.querySelector('.card-add-success-check');
      if (!check) return;
      window.anime.animate(check, {
        opacity: [0, 1, 1, 0],
        scale: [0.5, 1.1, 1, 0.9],
        duration: 1400,
        ease: 'outQuad'
      });
    }

    function handleCartIncrease() {
      bumpCartIcon();
      /* Confetti explodes from the cart icon itself (where the item just
         "landed"), not from the button that was clicked — reads as more causally
         correct, especially alongside the fly-to-cart image animation. But not
         on the cart page itself: you're already looking at the cart, so a big
         explosion there reads as redundant rather than delightful. */
      if (!isOnCartPage()) {
        var cartIcon = document.getElementById('cart-icon-bubble');
        if (cartIcon) {
          burstConfettiAt(cartIcon);
        }
      }
      var lastBtn = window.FunBooksCartFX.lastAddedButton;
      if (lastBtn) {
        showAddSuccessCheck(lastBtn);
        window.FunBooksCartFX.lastAddedButton = null;
      }
    }

    /* Image lookup, precise for the two known layouts:
       1. Grid cards (card-product.liquid): image lives inside .card-wrapper.
       2. Main product page (buy-buttons.liquid): the gallery (.product__media-wrapper)
          is a SIBLING branch of the buy button, not a close ancestor, and
          .product__info-container can contain other images first in document order
          (variant swatches, icon-with-text blocks, complementary product cards) —
          so we scope explicitly to .product__media-wrapper via the shared .product
          container instead of just grabbing the first <img> found while walking up.
       3. Anything else: best-effort ancestor walk, since we don't have that markup. */
    function findProductImageFor(form) {
      var card = form.closest('.card-wrapper');
      if (card) {
        var cardImg = card.querySelector('.card__media .media img');
        if (cardImg) return cardImg;
      }

      var productRoot = form.closest('.product');
      if (productRoot) {
        var galleryImg = productRoot.querySelector('.product__media-wrapper img');
        if (galleryImg) return galleryImg;
      }

      var node = form;
      for (var depth = 0; depth < 10 && node && node !== document.body; depth++) {
        node = node.parentElement;
        if (!node) break;
        var img = node.querySelector('img');
        if (img) return img;
      }
      return null;
    }

    /* Universal add-to-cart listener, registered here (not in card-product.liquid)
       specifically because header.liquid loads on every page, including templates
       that render their own add-to-cart form outside of card-product.liquid (the
       main product page's buy-buttons component, for example). This is now the
       single place that sets lastAddedButton and kicks off the fly-to-cart flight. */
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.matches || !form.matches('[data-type="add-to-cart-form"]')) return;
        var button = form.querySelector('[name="add"]');
        if (!button) return;
        window.FunBooksCartFX.lastAddedButton = button;

        var productImage = findProductImageFor(form);
        if (productImage) {
          flyToCart(productImage);
        }
      },
      true
    );

    var cartAnimationObserver = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var currentItemCount = getCartItemCount();
        if (currentItemCount > lastItemCount) {
          lastItemCount = currentItemCount;
          loadAnimeThen(handleCartIncrease);
        } else {
          lastItemCount = currentItemCount;
        }
      }, 60);
    });

    cartAnimationObserver.observe(iconsContainer, { childList: true, subtree: true, characterData: true });
  })();

  /* ---------- Header enhancement pack: announcement bar dismissal ---------- */
  document.addEventListener('click', function (event) {
    var dismissButton = event.target.closest('[data-announcement-dismiss]');
    if (!dismissButton) return;
    var sectionId = dismissButton.getAttribute('data-announcement-dismiss');
    var bar = document.getElementById('HeaderAnnouncementBar-' + sectionId);
    if (bar) bar.setAttribute('hidden', '');
    try {
      localStorage.setItem('header-announcement-dismissed-' + sectionId, '1');
    } catch (e) {}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animeLoading = false;

    function loadAnimeThen(callback) {
      if (window.anime) return callback();
      if (animeLoading) return;
      animeLoading = true;
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/animejs@4/dist/bundles/anime.umd.min.js';
      script.onload = function () {
        animeLoading = false;
        callback();
      };
      document.head.appendChild(script);
    }

    function initScrollReveal(wrapper) {
      if (reduceMotion) return;
      var items = wrapper.querySelectorAll('[data-newsletter-reveal]');
      if (!items.length) return;

      wrapper.classList.add('newsletter-reveal-armed');
      var revealed = false;

      var forceReveal = function () {
        if (revealed) return;
        revealed = true;
        wrapper.classList.remove('newsletter-reveal-armed');
        items.forEach(function (el) {
          el.style.opacity = '';
          el.style.transform = '';
        });
      };
      var safetyTimer = setTimeout(forceReveal, 3000);

      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || revealed) return;
          obs.unobserve(entry.target);
          loadAnimeThen(function () {
            if (revealed) return;
            clearTimeout(safetyTimer);
            revealed = true;
            wrapper.classList.remove('newsletter-reveal-armed');
            window.anime.animate(items, {
              opacity: [0, 1],
              translateY: [16, 0],
              delay: function (el, i) { return i * 90; },
              duration: 550,
              ease: 'outQuad'
            });
          });
        });
      }, { threshold: 0.2 });
      observer.observe(wrapper);
    }

    function burstConfetti(anchorEl) {
      var rect = anchorEl.getBoundingClientRect();
      var container = document.createElement('div');
      container.style.position = 'fixed';
      container.style.left = (rect.left + rect.width / 2) + 'px';
      container.style.top = (rect.top + rect.height / 2) + 'px';
      container.style.pointerEvents = 'none';
      container.style.zIndex = '9999';
      container.style.color = window.getComputedStyle(anchorEl).color;
      document.body.appendChild(container);

      var dots = [];
      var dotCount = 10;
      for (var i = 0; i < dotCount; i++) {
        var dot = document.createElement('span');
        dot.style.position = 'absolute';
        dot.style.width = '6px';
        dot.style.height = '6px';
        dot.style.borderRadius = '50%';
        dot.style.background = 'currentColor';
        dot.style.left = '0';
        dot.style.top = '0';
        container.appendChild(dot);
        dots.push(dot);
      }

      window.anime.animate(dots, {
        translateX: function (el, i) {
          var angle = (i / dotCount) * Math.PI * 2;
          return Math.cos(angle) * (28 + Math.random() * 18);
        },
        translateY: function (el, i) {
          var angle = (i / dotCount) * Math.PI * 2;
          return Math.sin(angle) * (28 + Math.random() * 18);
        },
        scale: [1, 0],
        opacity: [1, 0],
        duration: 700,
        ease: 'outCubic',
        onComplete: function () {
          container.remove();
        }
      });
    }

    function initFormFeedback(section) {
      var errorMessage = section.querySelector('.newsletter-form__message:not(.newsletter-form__message--success)');
      var successMessage = section.querySelector('.newsletter-form__message--success');
      var confettiEnabled = section.dataset.newsletterConfetti === 'true';

      if (reduceMotion) return;

      if (errorMessage) {
        loadAnimeThen(function () {
          window.anime.animate(errorMessage, {
            translateX: [0, -8, 8, -6, 6, 0],
            duration: 420,
            ease: 'outQuad'
          });
        });
      }

      if (successMessage) {
        loadAnimeThen(function () {
          window.anime.animate(successMessage, {
            scale: [0.9, 1],
            opacity: [0, 1],
            duration: 400,
            ease: window.anime.createSpring({ stiffness: 280, damping: 16 })
          });
          if (confettiEnabled) {
            burstConfetti(successMessage);
          }
        });
      }
    }

    function initLoadingState(section) {
      var form = section.querySelector('.newsletter-form');
      var button = section.querySelector('.newsletter-form__button');
      if (!form || !button || button.dataset.loadingState !== 'true') return;

      form.addEventListener('submit', function () {
        if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      });
    }

    function initInlineValidation(section) {
      var input = section.querySelector('.field__input');
      if (!input || input.dataset.inlineValidation !== 'true') return;

      input.addEventListener('blur', function () {
        if (input.value === '') {
          input.classList.remove('field__input--invalid');
          return;
        }
        input.classList.toggle('field__input--invalid', !input.validity.valid);
      });

      input.addEventListener('input', function () {
        if (input.classList.contains('field__input--invalid') && input.validity.valid) {
          input.classList.remove('field__input--invalid');
        }
      });
    }

    document.querySelectorAll('[data-newsletter-animations]').forEach(function (section) {
      initLoadingState(section);
      initInlineValidation(section);
      if (section.dataset.newsletterAnimations === 'true') {
        initFormFeedback(section);
        initScrollReveal(section.querySelector('.newsletter__wrapper'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
